export const DIA_CHI_NHAN_HANG_PERMISSION_CODES = {
  WEB_BH_DIA_CHI_NHAN_HANG_LIST: 'WEB_BH_DIA_CHI_NHAN_HANG_LIST',
  WEB_BH_DIA_CHI_NHAN_HANG_ADD: 'WEB_BH_DIA_CHI_NHAN_HANG_ADD',
  WEB_BH_DIA_CHI_NHAN_HANG_EDIT: 'WEB_BH_DIA_CHI_NHAN_HANG_EDIT',
  WEB_BH_DIA_CHI_NHAN_HANG_DELETE: 'WEB_BH_DIA_CHI_NHAN_HANG_DELETE',
} as const

export type DiaChiNhanHangPermissionCode =
  (typeof DIA_CHI_NHAN_HANG_PERMISSION_CODES)[keyof typeof DIA_CHI_NHAN_HANG_PERMISSION_CODES]

export const DIA_CHI_NHAN_HANG_MUTATE_PERMISSIONS = [
  DIA_CHI_NHAN_HANG_PERMISSION_CODES.WEB_BH_DIA_CHI_NHAN_HANG_ADD,
  DIA_CHI_NHAN_HANG_PERMISSION_CODES.WEB_BH_DIA_CHI_NHAN_HANG_EDIT,
  DIA_CHI_NHAN_HANG_PERMISSION_CODES.WEB_BH_DIA_CHI_NHAN_HANG_DELETE,
] as const
